import gql from "graphql-tag";

export const USER_REGISTER = gql`
  mutation register(
    $email: citext!
    $firstName: String!
    $lastName: String!
    $password: String!
    $venueType: String!
  ) {
    signup(
      firstName: $firstName
      lastName: $lastName
      password: $password
      email: $email
      venueType: $venueType
    ) {
      tokenKey
      userId
    }
  }
`;

export const LOGIN = gql`
  mutation login($password: String!, $email: citext!) {
    login(email: $email, password: $password) {
      tokenKey
      userId
    }
  }
`;

export const START_ORDER = gql`
  mutation StartOrder($menuId: uuid!, $tableId: uuid) {
    startOrder(menuId: $menuId, tableId: $tableId) {
      orderId
      tokenKey
    }
  }
`;
export const FORGOT_PASSWPRD = gql`
  mutation MyMutation($email: String!) {
    forgotPassword(email: $email) {
      affected_rows
    }
  }
`;

export const RESET_PASSWORD = gql`
  mutation MyMutation(
    $email: String!
    $newPassword: String!
    $resetPasswordToken: String!
  ) {
    resetPassword(
      newPassword: $newPassword
      resetPasswordToken: $resetPasswordToken
      email: $email
    ) {
      affected_rows
    }
  }
`;
